/* @flow */
import ConfirmDialog from 'components/ConfirmDialog.jsx';
import Glyph from 'components/Glyph.jsx';
import Group from 'entities/Group';
import GroupActions from 'groups/actions/GroupActions';
import GroupMembership from 'entities/GroupMembership';
import ModalMenuItem from 'components/ModalMenuItem.jsx';
import React from 'react';
import ToastActions from 'actions/ToastActions';

class RemoveMemberMenuItem extends React.Component {
  static propTypes = {
    group: React.PropTypes.instanceOf(Group).isRequired,
    member: React.PropTypes.instanceOf(GroupMembership).isRequired,
  };

  removeMember = () => {
    const subscriber = this.props.member.getUser();
    const message = `${subscriber.getName()} was removed from ${this.props.group.getName()}`;
    GroupActions.removeMember(this.props.group, subscriber)
      .then(() => ToastActions.showSuccessToast(message));
  };

  renderConfirmDialog = () => {
    return (
      <ConfirmDialog
        eventScreenName="RemoveMemberMenuItem"
        actionButtonText="Remove"
        cancelButtonText="Cancel"
        size="xsmall"
        onConfirm={this.removeMember}
        title="Remove participant?"
        subtext={'This person won’t receive announcements or be available ' +
          'for direct messaging. You can always change this later.'}
      />
    );
  };

  render() {
    return (
      <ModalMenuItem modal={this.renderConfirmDialog()}>
        <Glyph name="close" />
        <span>
          Remove from class
        </span>
      </ModalMenuItem>
    );
  }
}

export default RemoveMemberMenuItem;



// WEBPACK FOOTER //
// ./src/groups/components/RemoveMemberMenuItem.jsx